{
	"sent": {
		"title": "Conférence envoyée",
		"tooltip": "Conférence de caisse envoyée au service financier."
	},
	"pending": {
		"title": "Conférence en attente",
		"tooltip": "Conférence de caisse en attente d'envoi au service financier."
	},
	"openPdv": "PDV ouverts",
	"openTable": "Tables extérieures"
}
